import SkipLinks from 'design-comuni-plone-theme/components/ItaliaTheme/SkipLinks/SkipLinks';

export default SkipLinks;
